import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { ChecklistItem } from "models/interfaces/block-configurations/checklist-item";
import { ChecklistItemNoteRecord } from "models/view-models/checklist-item-notes/checklist-item-note-record";

const defaultValues: ChecklistItem =
    RecordUtils.auditableDefaultValuesFactory<ChecklistItem>({
        configurationId: 0,
        isChecked: false,
        note: undefined,
        sortIndex: 0,
        status: undefined,
        text: "",
    });

export class ChecklistItemRecord
    extends Record(defaultValues)
    implements ChecklistItem
{
    constructor(params?: Partial<ChecklistItem>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.note != null) {
            params.note = RecordUtils.ensureRecord(
                params.note,
                ChecklistItemNoteRecord
            );
        }

        super(params);
    }

    public with(values: Partial<ChecklistItem>): ChecklistItemRecord {
        return new ChecklistItemRecord(Object.assign(this.toJS(), values));
    }
}
